/**
 * Sanitizer voor de glas-maatvoeringstekening (drawingSvg) die als rauwe HTML in
 * facturen en de Timmers-bestelbon wordt gerenderd (document.write → admin-context).
 *
 * `drawingSvg` komt uit de publieke createOrder-callable en is dus door de klant te
 * bepalen. Zonder sanering kan een geprepareerde order een <script>/onerror-payload
 * bevatten die in de geauthenticeerde admin-sessie uitvoert (stored XSS).
 *
 * De legitieme tekening (serializeDrawing) is pure vector-SVG: rect/line/path/text +
 * presentatie-attributen en `style="…var(--…)"`. Die strippen we niet; we verwijderen
 * uitsluitend de actieve/onveilige onderdelen. Werkt zonder DOM (Node + browser), zodat
 * zowel de Functions-backend (intake) als de client (render) hem kan gebruiken.
 */
export function sanitizeDrawingSvg(svg: string | null | undefined): string {
  if (!svg) return "";
  let s = String(svg);

  // 1. Verwijder gevaarlijke elementen inclusief hun inhoud.
  s = s.replace(/<\s*script[\s\S]*?<\s*\/\s*script\s*>/gi, "");
  s = s.replace(/<\s*foreignObject[\s\S]*?<\s*\/\s*foreignObject\s*>/gi, "");
  s = s.replace(/<\s*style[\s\S]*?<\s*\/\s*style\s*>/gi, "");

  // 2. Strip ook losse open/zelfsluitende tags die scripting/embedding toelaten
  //    (script, foreignObject, iframe, embed, object, link, meta, en SMIL-animaties
  //    die via attributeName="onload" alsnog handlers kunnen zetten).
  s = s.replace(/<\s*\/?\s*(?:script|foreignObject|iframe|embed|object|link|meta|base|set|animate\w*)\b[^>]*>/gi, "");

  // 3. Verwijder alle on*-event-handler-attributen (onload, onerror, onclick, …).
  s = s.replace(/\son[a-z-]+\s*=\s*"[^"]*"/gi, "");
  s = s.replace(/\son[a-z-]+\s*=\s*'[^']*'/gi, "");
  s = s.replace(/\son[a-z-]+\s*=\s*[^\s/>]+/gi, "");

  // 4. Neutraliseer javascript:-URLs (ook in href/xlink:href en url(...)).
  s = s.replace(/javascript:/gi, "");

  return s;
}
